import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (typeof document !== 'undefined') {
  const el = document.documentElement;
  [...el.classList].forEach((c) => {
    if (c.startsWith('page-theme-')) el.classList.remove(c);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
